var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 46.5L20.44 28.762A16.79 16.79 0 0133 1.125a16.665 16.665 0 0116.5 16.768 16.912 16.912 0 01-3.712 10.58L33 46.5zm0-41.25a12.52 12.52 0 00-12.375 12.643 12.767 12.767 0 003.073 8.25L33 39.323l9.55-13.448a12.87 12.87 0 002.825-7.982A12.52 12.52 0 0033 5.25z",
    fill: "#2E5ECC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19.688a4.125 4.125 0 100-8.25 4.125 4.125 0 000 8.25zM57.75 21.75h-4.125v4.125h4.125V54.75H8.25V25.875h4.125V21.75H8.25a4.125 4.125 0 00-4.125 4.125V54.75a4.125 4.125 0 004.125 4.125h49.5a4.125 4.125 0 004.125-4.125V25.875a4.125 4.125 0 00-4.125-4.125z",
    fill: "#2E5ECC"
  })));
}

export default SvgLocationContact;